import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    iconReset: {
        fill: theme.palette.error.main,
        margin: 0,
        cursor: "pointer"
    }
}))